// @flow;

export const OPEN_LOGOUT_MODAL: string = 'OPEN_LOGOUT_MODAL';
export function openLogoutModal(): { type: string } {
  return {
    type: OPEN_LOGOUT_MODAL
  };
}
